import { FormattedMessage } from 'react-intl';
import { ListIcon } from '@chakra-ui/react';
import { Button } from '@chakra-ui/react';

import CustomNavLink from '../../utils/CustomNavLink';

const ActiveLink = ({ icon, onClick, to, messageId, ...rest }) => {
    const content = (
        <>
            {icon && (
                <span>
                    <ListIcon as={icon} />
                </span>
            )}

            <FormattedMessage id={messageId} />
        </>
    );

    return to == null ? (
        <Button onClick={onClick} {...rest}>
            {content}
        </Button>
    ) : (
        <CustomNavLink exact to={to} activeStyle={{ color: 'black' }} onClick={onClick} {...rest}>
            {content}
        </CustomNavLink>
    );
};

export default ActiveLink;
